export default __webpack_public_path__ + "static/media/location.379a3ef8.png";